import { createSlice } from '@reduxjs/toolkit';

// initial state for leave management
export const initialLeaveManagement = {
    user_name: "",
    user_id: "",
    leave_Pending: 0,
    leave_Approved: 0,
    leave_Rejected: 0,
    user_type: "",
    user_profile: "",
}

const leaveManagementInfo = sessionStorage.getItem('leaveManagementInfo') !== null ?
JSON.parse(sessionStorage.getItem("leaveManagementInfo")) : initialLeaveManagement

const initialState = {
    form: {
        addLeaveManagementForm: leaveManagementInfo,
        rejectLeaveManagementForm: null,
        approveLeaveManagementForm: null,
    },
    popup: {
        approveLeavePopup: false,
        rejectLeavePopup: false
    }
}

export const leaveManagement = createSlice({
    name: "leaveManagement",
    initialState,
    reducers: {
        addLeaveManagementForm: (state, action) => {
            state.form.addLeaveManagementForm = action.payload
            sessionStorage.setItem('leaveManagementInfo', JSON.stringify(state.form.addLeaveManagementForm))
        },
        OpenApproveLeavePopup: (state, action) => {
            state.popup.approveLeavePopup = true
            state.form.approveLeaveManagementForm = action.payload
        },
        CloseApproveLeavePopup: (state) => {
            state.popup.approveLeavePopup = false
            state.form.approveLeaveManagementForm = null
        },
        OpenRejectLeavePopup: (state, action) => {
            state.popup.rejectLeavePopup = true
            state.form.rejectLeaveManagementForm = action.payload
        },
        CloseRejectLeavePopup: (state) => {
            state.popup.rejectLeavePopup = false
        },
    }
})

export const { addLeaveManagementForm, OpenApproveLeavePopup, CloseApproveLeavePopup,
    OpenRejectLeavePopup, CloseRejectLeavePopup } = leaveManagement.actions

export const getLeaveManagementForm = (state) => state.leaveManagement.form.addLeaveManagementForm
export const getApproveLeavePopup = (state) => state.leaveManagement.popup.approveLeavePopup
export const getRejectLeavePopup = (state) => state.leaveManagement.popup.rejectLeavePopup
export const getApproveLeaveForm = (state) => state.leaveManagement.form.approveLeaveManagementForm
export const getRejectLeaveForm = (state) => state.leaveManagement.form.rejectLeaveManagementForm

export default leaveManagement.reducer